import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrepentimientoModal } from "../home/bloques/ArrepentimientoModal";
import { useRazonSocial } from "../../utils/razonSocial";

export const Footer = () => {
    const razonSocial = useRazonSocial();
    const [info, setinfo] = useState(null)
    useEffect(() => {
        fetch("/config_generales")
            .then(res => res.json())
            .then(result => {
                setinfo(result)
            });
    }, []);

    let handleOpen = () => {
        let backdrop = document.querySelector(".form-modalBackdrop");
        backdrop.style.opacity = "1";
        backdrop.style.zIndex = "99999";

        let form = document.querySelector(".form-modalScreen");
        form.style.opacity = "1";
        form.style.zIndex = "999999";

        document.getElementById("cuit-focus").focus();
    };

    let handleClose = () => {
        let backdrop = document.querySelector(".form-modalBackdrop");
        backdrop.style.opacity = "0";
        backdrop.style.zIndex = "-1";

        let form = document.querySelector(".form-modalScreen");
        form.style.opacity = "0";
        form.style.zIndex = "-1";
    };

    return (
        <footer className="footer">
            <div className="footer--container">
                <div className="innerDiv">
                    <Link className="link--footer" to={"/acto_de_adjudicacion"}>
                        <h2>Acto de adjudicación</h2>
                        <img src="/images/icons/arrow-right-white.svg" />
                    </Link>
                    <div className="separator--hor"></div>
                    <Link className="link--footer" to={"/conoce_leapmotor_plan"}>
                        <h2>Conocé Leapmotor Plan</h2>
                        <img src="/images/icons/arrow-right-white.svg" />
                    </Link>
                    <div className="separator--hor"></div>
                    <Link className="link--footer" to={"/preguntas_frecuentes"}>
                        <h2>Preguntas frecuentes</h2>
                        <img src="/images/icons/arrow-right-white.svg" />
                    </Link>
                    <div className="separator--hor"></div>
                    <Link className="link--footer" to={"/informacion_general"}>
                        <h2>Información general</h2>
                        <img src="/images/icons/arrow-right-white.svg" />
                    </Link>
                    <div className="link--footer" style={{ cursor: "pointer" }} onClick={handleOpen}>
                        <h2>Arrepentimiento</h2>
                        <img src="/images/icons/arrow-right-white.svg" />
                    </div>

                    <ArrepentimientoModal handleClose={handleClose} />

                    <div className="separator--hor"></div>
                </div>
                <div className="separator--ver"></div>
                <div className="innerDiv">
                    <Link className="link--footer" to={'/gastos_de_entrega'}>
                        <h2>Gastos de Entrega</h2>
                        <img src="/images/icons/arrow-right-white.svg" />
                    </Link>
                    <a
                        className="link--footer"
                        target="_blank"
                        href="https://leapmotorstore.com.ar/mapa-concesionarios"
                    >
                        <h2>Concesionarios</h2>
                        <img src="/images/icons/arrow-right-white.svg" />
                    </a>
                    <div className="separator--hor"></div>
                    <Link
                        className="link--footer"
                        to={"/terminos_y_condiciones"}
                    >
                        <h2>Términos y condiciones</h2>
                        <img src="/images/icons/arrow-right-white.svg" />
                    </Link>
                    <div className="separator--hor"></div>
                    <h2>Sede Social</h2>
                    <h2 className="font-weight-light">
                        {info !== null && info.direccion_footer}
                    </h2>
                    <div className="separator--hor"></div>
                </div>
                <div className="separator--ver"></div>
                <div className="innerDiv innerDiv--contacto py-half py-xl-0">
                    <h2 className="font-weight-light">
                        Atención clientes Leapmotor Plan
                    </h2>

                    <a href={`tel:${info !== null && info.telefono_footer}`}><h1>{info !== null && info.telefono_footer}</h1></a>
                    <a href={`mailto:${info !== null && info.email_footer}`}>{info !== null && info.email_footer}</a>
                </div>
                <div className="separator--ver"></div>
                <div className="separator--hor"></div>
                <div className="innerDiv pt-half pt-xl-0 ">
                    <div className="d-flex row innerDiv--main">
                        <div className="col-8">
                            <p className="font-weight-light">
                                Copyright © {razonSocial.minusculas}. Todos los derechos reservados.
                                Leapmotor® Plan es un plan administrado por {razonSocial.titulo}
                            </p>
                        </div>
                        <div className="col-4 d-flex justify-content-end">
                            <a href="https://serviciosweb.afip.gob.ar/clavefiscal/qr/publicInfoD.aspx" target="_blank">
                                <img
                                    className="dataFiscal"
                                    src="/images/icons/footer.png"
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};
